"use client";

import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "@/lib/query-keys";
import {
  fetchCourseEligibilityStatus,
  type Course,
} from "./api";

export function useCourseEligibilityStatus(
  course: Pick<Course, "slug" | "eligibility">,
  enabled: boolean,
) {
  return useQuery({
    queryKey: queryKeys.courses.eligibilityStatus(course.slug),
    queryFn: () => fetchCourseEligibilityStatus(course.slug),
    enabled: enabled && !!course.eligibility,
    staleTime: 0,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
  });
}

